export type DepositType = 'Undefined' | 'Deposit' | 'Credit';

export const DepositType = {
  Undefined: 'Undefined' as DepositType,
  Deposit: 'Deposit' as DepositType,
  Credit: 'Credit' as DepositType,
};
